import { Expose } from "class-transformer";
import { IsArray } from "class-validator";

export class GetCityOfUsersDTO {
  @Expose()
  @IsArray()
  cities!: string[];
}
